<div class="rm-portal-container">
  <!-- Top Navigation Bar -->
  <header class="portal-nav">
    <div class="brand">
      <div class="logo-badge"><i class="bi bi-person-badge-fill"></i></div>
      <div class="brand-text">
        <span class="sub">VIP CONCIERGE</span>
        <span class="main">RM Dashboard</span>
      </div>
    </div>

    <div class="nav-right">
      <button class="btn-search-nav" (click)="openSearch()">
        <i class="bi bi-search"></i> Manual Profile Search
      </button>
      <div class="user-profile-badge" *ngIf="rmUser">
        <div class="avatar-circle">{{ rmUser.name?.charAt(0) || 'R' }}</div>
        <div class="info">
          <span class="name">{{ rmUser.name }}</span>
          <span class="id">ID: {{ rmUser.employee_id }}</span>
        </div>
      </div>
      <button class="btn-logout" (click)="logout()" title="Log out">
        <i class="bi bi-box-arrow-right"></i>
      </button>
    </div>
  </header>

  <main class="portal-content">
    <div *ngIf="loading" class="empty-state">
      <div class="spinner-border" style="color: var(--color-primary, #B01E3E);" role="status"></div>
      <p class="mt-3">Synchronizing your Express client portfolio...</p>
    </div>

    <ng-container *ngIf="!loading">
      <!-- KPI Cards Row -->
      <div class="kpi-row">
        <div class="kpi-card">
          <div class="kpi-icon"><i class="bi bi-people-fill"></i></div>
          <div class="kpi-data">
            <span class="label">Assigned Clients</span>
            <div class="val">{{ stats.assigned_clients }} <small>/ {{ rmUser?.max_client_capacity || 50 }} Cap</small></div>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-icon"><i class="bi bi-chat-dots-fill"></i></div>
          <div class="kpi-data">
            <span class="label">Pending Replies</span>
            <span class="val">{{ stats.pending_replies }}</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-icon"><i class="bi bi-list-check"></i></div>
          <div class="kpi-data">
            <span class="label">Tasks Today</span>
            <span class="val">{{ stats.tasks_today }}</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-icon"><i class="bi bi-calendar-event-fill"></i></div>
          <div class="kpi-data">
            <span class="label">Meetings / Calls</span>
            <span class="val">{{ stats.meetings }}</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-icon"><i class="bi bi-stars"></i></div>
          <div class="kpi-data">
            <span class="label">New Express Subscribers</span>
            <span class="val">{{ stats.new_express_subscribers }}</span>
          </div>
        </div>
      </div>

      <!-- Clients Section -->
      <section class="portfolio-section">
        <div class="section-top">
          <div class="title-area">
            <h3>Your Express Client Portfolio</h3>
            <p>Select any client to open their dedicated 3-panel workspace, manage tasks, and initiate website chat.</p>
          </div>

          <div class="actions-area">
            <div class="search-box">
              <i class="bi bi-search"></i>
              <input
                type="text"
                placeholder="Search by client name or mobile..."
                [(ngModel)]="searchTerm"
                (input)="filterClients()"
              />
            </div>

            <select [(ngModel)]="selectedStageFilter" (change)="filterClients()" class="filter-select">
              <option *ngFor="let stage of stages" [value]="stage">Stage: {{ stage }}</option>
            </select>
          </div>
        </div>

        <!-- Clients Table -->
        <div class="table-wrapper" *ngIf="filteredClients.length > 0">
          <table class="clients-table">
            <thead>
              <tr>
                <th>Client Details</th>
                <th>Contact Info</th>
                <th>Current Progress Stage</th>
                <th>Last Message Preview</th>
                <th>Assigned Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let client of filteredClients" (click)="openClientWorkspace(client._id)" style="cursor: pointer;">
                <td>
                  <div class="client-info-cell">
                    <div class="client-avatar">
                      <img *ngIf="clientPhotos[client._id]" [src]="clientPhotos[client._id]" alt="avatar" />
                      <span *ngIf="!clientPhotos[client._id]">{{ client.name.charAt(0) }}</span>
                    </div>
                    <div class="client-name-id">
                      <span class="c-name">{{ client.name }}</span>
                      <span class="c-id">ID: #{{ client._id?.toString()?.slice(-6)?.toUpperCase() }}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="contact-cell">
                    <span><i class="bi bi-telephone-fill"></i> {{ client.phone }}</span>
                  </div>
                </td>
                <td>
                  <span class="stage-pill">{{ client.current_stage }}</span>
                </td>
                <td>
                  <div class="activity-cell">
                    <span *ngIf="client.last_message_preview" class="last-msg">{{ client.last_message_preview }}</span>
                    <span *ngIf="!client.last_message_preview" class="last-msg" style="color: #94a3b8;">No messages yet</span>
                    <span *ngIf="client.last_chat" class="time">{{ client.last_chat | date:'shortTime' }}</span>
                  </div>
                </td>
                <td>
                  <span style="font-weight: 500; color: var(--color-on-surface-variant, #4d4d4d);">{{ client.assigned_date | date:'mediumDate' }}</span>
                </td>
                <td>
                  <button class="btn-open-workspace" (click)="$event.stopPropagation(); openClientWorkspace(client._id)">
                    Open Workspace <i class="bi bi-arrow-right-short"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty State -->
        <div *ngIf="filteredClients.length === 0" class="empty-state">
          <i class="bi bi-people"></i>
          <h4>No Clients Found</h4>
          <p>We couldn't find any Express plan clients matching your search or stage filters.</p>
        </div>
      </section>
    </ng-container>
  </main>
</div>
